import { Component, Input, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { NotificationsService } from 'src/app/notifications/notifications.service';

@Component({
  selector: 'app-mail-marketing-test',
  templateUrl: './mail-marketing-test.component.html',
  styleUrls: ['./mail-marketing-test.component.scss']
})
export class MailMarketingTestComponent implements OnInit {
  public marketingTest: any = {};
  public errorMessage: string = "";
  

  constructor( private messageService: MessageService,
    private dynamicDialogRef: DynamicDialogRef, 
    private notificationsService: NotificationsService,
    public config: DynamicDialogConfig) { }

  ngOnInit() {
    this.errorMessage = "";
    this.marketingTest.id = this.config.data.notificationId;
  }

  send(){
    //console.log(this.marketingTest);
    this.notificationsService.sendTest(this.marketingTest.id, this.marketingTest.email).subscribe(
      data => {
        this.dynamicDialogRef.close(); 
      },
      error => {
        this.messageService.add({ closable: false, severity: "error", detail: error.error.title });
      }
    )
  }
  
  cancel() {
    this.dynamicDialogRef.close();
  }

}
